// src/redux/chargeApi.js
import { apiSlice } from "./apiSlice";

export const chargeApi = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        // GET /api/user/charge/v1 - 청구 리스트 조회
        getChargeList: build.query({
            query: () => ({
                url: "/api/user/charge/v1",
                method: "GET",
                headers: { token: true },
            }),
        }),
        // POST /api/user/charge/v1 - 청구하기
        postCharge: build.mutation({
            query: (body) => ({
                url: "/api/user/charge/v1",
                method: "POST",
                headers: { token: true },
                data: body,
            }),
        }),
        // POST /api/user/charge/v1/pre_charge - 선 청구하기
        postPreCharge: build.mutation({
            query: (body) => ({
                url: "/api/user/charge/v1/pre_charge",
                method: "POST",
                headers: { token: true },
                data: body,
            }),
        }),
        // GET /api/user/charge/v1/{chargeId} - 청구 상세조회
        getChargeDetail: build.query({
            query: (chargeId) => ({
                url: `/api/user/charge/v1/${chargeId}`,
                method: "GET",
                headers: { token: true },
            }),
        }),
    }),
});

export const { useGetChargeListQuery, usePostChargeMutation, usePostPreChargeMutation, useGetChargeDetailQuery } = chargeApi;
